






import Vue from "vue";
import Component from "vue-class-component";
import { CrudService } from "../core/services/crudService";
import { Settings, SettingsService } from "../core/services/configService";
import { CustomerHelper } from "../crm/helpers/customerHelper";
import ProgramPage from "../components/programs/ProgramPage.vue";
import ProgramReports from "../components/programs/ProgramReports.vue";

@Component({
  components: { ProgramPage, ProgramReports },
})
export default class MyReportsPage extends Vue {
  reports: any[] = [];
  loaded: boolean = false;

  get emptyText(): string {
    return this.loaded && this.reports.length === 0 ? this.$t("You do not have any report yet").toString() : "";
  }

  async mounted() {
    new SettingsService().setPageTitle(this.$t("Reports").toString());
    const data = await new CrudService().httpGet(`${Settings.HostName}/api/publicreports/customer/${CustomerHelper.getStoredCustomer()}`);
    this.reports = data && data.ok ? data.data : [];
    this.loaded = true;
  }
}
